import YouTube from 'react-youtube'
import styled, { css } from 'styled-components'

import { setBackground } from 'utils/styled/setBackground'

export const Cover = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity ${p => p.theme.animation.timeStandard} ease-in;
  opacity: 1;
  background: transparent center / cover no-repeat;
  ${({ cover }) => setBackground('jpg', cover, { xs: 320, md: 1280 })};

  ${p => p.theme.mq.upMd} {
    background-position: 0 0;
  }

  ${p =>
    (p.state === 'entering' || p.state === 'entered') &&
    css`
      opacity: 1;
      pointer-events: all;
    `}

  ${p =>
    (p.state === 'exiting' || p.state === 'exited') &&
    css`
      opacity: 0;
    `}

  ${p =>
    p.state === 'exited' &&
    css`
      pointer-events: none;
    `}

  ${({ withContent }) =>
    withContent &&
    css`
      flex-direction: column;
    `}
`

export const ButtonWrapper = styled.div`
  position: relative;
  z-index: 10;
`

export const StyledYouTube = styled(YouTube)`
  width: 100%;
  height: 100%;

  ${({ isPlay }) =>
    isPlay &&
    css`
      position: relative;
      z-index: 10;
    `}
`

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`
